import { isNil } from 'ramda';
import { useEffect, useRef } from 'react';
import { now } from '../../env/performance';
import { useMMGRSettings } from '../../hoc/withMMGRSettings';
import { getActiveItemFilter } from '../../publicMedia';
import { FilterName } from '../../../constants/FilterName';
import { bi } from '../../../services/loggers/bi';
import { MediaManagerSDKAnyItem } from '../../media-manager-sdk';
import { IExtendedFilter } from '../../../containers/FilesManager/ExtendedItemsFilters/ExtendedItemsFilters.types';
import { Source } from '../../../constants/Source';
import { isUnsplash } from '../../media-manager-sdk/sources';
import { MediaType } from '../../../constants/MediaType';
import { useAdapter } from '../useAdapter';
import { mediaManagerNextPageRender } from '@wix/bi-logger-media-data/v2';

interface IUseTrackNextPageRender {
  isLoading: boolean;
  areNextFilesLoading: boolean;
  source: Source;
  items: MediaManagerSDKAnyItem[];
  itemsFilters: IExtendedFilter[];
}

export const useTrackNextPageRender = ({
  isLoading,
  source,
  itemsFilters,
  items,
  areNextFilesLoading,
}: IUseTrackNextPageRender) => {
  const loadingTimeTS = useRef(now());
  const adapter = useAdapter(source);
  const {
    mmgrSettings: { team },
  } = useMMGRSettings();

  useEffect(() => {
    if (isLoading) {
      return;
    }

    const activeFilter = isUnsplash(source)
      ? { mediaType: MediaType.Picture }
      : getActiveItemFilter(itemsFilters, FilterName.Type);

    bi.logger().report(
      mediaManagerNextPageRender({
        correlationId: adapter.correlationId ? adapter.correlationId.getPrevious() : null,
        context: activeFilter && activeFilter.mediaType,
        loadingTime: Math.round(now() - loadingTimeTS.current),
        ...(isNil(team) ? {} : { teammate_id: window.userId }),
      }),
    );
  }, [items]);

  useEffect(() => {
    if (isLoading || areNextFilesLoading) {
      loadingTimeTS.current = now();
    }
  }, [isLoading, areNextFilesLoading]);
};
